angular.module("vgresiduos").component("customReportData", {
	controller: "CustomReportDataCtrl",
	templateUrl: "views/customReports/components/customReportData/customReportData_template.html",
	bindings: {
		data: "<",
		fileName: "<?",
		information: "<"
	}
});
